import type { TicketUser } from '../hooks/useTickets';

export function userDisplayName(user?: TicketUser | null): string {
  if (!user) return '—';
  if (user.fullName?.trim()) return user.fullName.trim();
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name || user.email || '—';
}

export function formatSlot(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export interface SessionLinkedTicket {
  id: string;
  ticketNumber?: string | null;
  branchId?: number | null;
  roomId?: number | null;
  bookingId?: number | null;
  slotStartAt?: string | null;
  customerName?: string | null;
  title?: string;
  status?: string;
  finalVideoFilename?: string | null;
}

export function formatSessionTicketContext(ticket?: SessionLinkedTicket | null): string | null {
  if (!ticket) return null;
  const parts: string[] = [];
  if (ticket.ticketNumber) parts.push(ticket.ticketNumber);
  if (ticket.branchId != null) parts.push(`Branch #${ticket.branchId}`);
  if (ticket.roomId != null) parts.push(`Room #${ticket.roomId}`);
  if (ticket.slotStartAt) parts.push(formatSlot(ticket.slotStartAt));
  return parts.length > 0 ? parts.join(' · ') : ticket.title || null;
}
